// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs[data-v-bccbfe00]{align-items:center;color:var(--gray--200);display:flex;flex-wrap:wrap;font-size:.875rem;gap:4px}.breadcrumbs__sep[data-v-bccbfe00]{color:var(--gray--200);opacity:.5}.breadcrumbs__item--current[data-v-bccbfe00]{color:var(--black--200)}.breadcrumbs .link[data-v-bccbfe00]{--primary-color:var(--gray--200);--hover-color:var(--black--200)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
